// @flow

// Effect Managers
// import { fork, put, take, call, spawn, cancel, cancelled } from 'redux-saga/effects'
//

export function *initializeApp (): Generator<*, *, *> {

}

export default function *main (): Generator<*, *, *> {

}
